// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file jira/v1/jira_service.proto (package jira.v1, syntax proto3)
/* eslint-disable */

import { JiraService } from "./jira_service_pb";

/**
 * @generated from rpc jira.v1.JiraService.SetCredentialsAndSettings
 */
export const setCredentialsAndSettings = JiraService.method.setCredentialsAndSettings;

/**
 * @generated from rpc jira.v1.JiraService.GetSettings
 */
export const getSettings = JiraService.method.getSettings;

/**
 * @generated from rpc jira.v1.JiraService.CreateIssue
 */
export const createIssue = JiraService.method.createIssue;

/**
 * @generated from rpc jira.v1.JiraService.CreateIssuesBulk
 */
export const createIssuesBulk = JiraService.method.createIssuesBulk;

/**
 * @generated from rpc jira.v1.JiraService.ListProjects
 */
export const listProjects = JiraService.method.listProjects;

/**
 * @generated from rpc jira.v1.JiraService.ListProjectIssueTypes
 */
export const listProjectIssueTypes = JiraService.method.listProjectIssueTypes;

/**
 * @generated from rpc jira.v1.JiraService.GetIssueTypeMetadata
 */
export const getIssueTypeMetadata = JiraService.method.getIssueTypeMetadata;

/**
 * @generated from rpc jira.v1.JiraService.GetCreatedIssues
 */
export const getCreatedIssues = JiraService.method.getCreatedIssues;

/**
 * @generated from rpc jira.v1.JiraService.DisconnectCreatedIssue
 */
export const disconnectCreatedIssue = JiraService.method.disconnectCreatedIssue;
